export default __webpack_public_path__ + "static/media/before_2_implants.04898d53.png";